/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetReservationNotificationsV2200Response,
  UpsertReservationNotificationRequest,
} from '../models/index';
import {
    GetReservationNotificationsV2200ResponseFromJSON,
    GetReservationNotificationsV2200ResponseToJSON,
    UpsertReservationNotificationRequestFromJSON,
    UpsertReservationNotificationRequestToJSON,
} from '../models/index';

export interface GenerateNotificationEmailPreviewRequest {
    notificationType: GenerateNotificationEmailPreviewNotificationTypeEnum;
}

export interface UpsertReservationNotificationOperationRequest {
    notificationType: UpsertReservationNotificationNotificationTypeEnum;
    upsertReservationNotificationRequest?: UpsertReservationNotificationRequest;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     */
    async generateNotificationEmailPreviewRaw(requestParameters: GenerateNotificationEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['notificationType'] == null) {
            throw new runtime.RequiredError(
                'notificationType',
                'Required parameter "notificationType" was null or undefined when calling generateNotificationEmailPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/notifications/{notificationType}`.replace(`{${"notificationType"}}`, encodeURIComponent(String(requestParameters['notificationType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async generateNotificationEmailPreview(requestParameters: GenerateNotificationEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.generateNotificationEmailPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationNotificationsV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationNotificationsV2200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/notifications/v2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationNotificationsV2200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationNotificationsV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationNotificationsV2200Response> {
        const response = await this.getReservationNotificationsV2Raw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertReservationNotificationRaw(requestParameters: UpsertReservationNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['notificationType'] == null) {
            throw new runtime.RequiredError(
                'notificationType',
                'Required parameter "notificationType" was null or undefined when calling upsertReservationNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/notifications/{notificationType}`.replace(`{${"notificationType"}}`, encodeURIComponent(String(requestParameters['notificationType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertReservationNotificationRequestToJSON(requestParameters['upsertReservationNotificationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationNotification(requestParameters: UpsertReservationNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationNotificationRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GenerateNotificationEmailPreviewNotificationTypeEnum = {
    Confirmation: 'confirmation',
    Reminder: 'reminder',
    Modification: 'modification',
    Cancellation: 'cancellation',
    Experience: 'experience'
} as const;
export type GenerateNotificationEmailPreviewNotificationTypeEnum = typeof GenerateNotificationEmailPreviewNotificationTypeEnum[keyof typeof GenerateNotificationEmailPreviewNotificationTypeEnum];
/**
 * @export
 */
export const UpsertReservationNotificationOperationNotificationTypeEnum = {
    Confirmation: 'confirmation',
    Reminder: 'reminder',
    Modification: 'modification',
    Cancellation: 'cancellation',
    Experience: 'experience'
} as const;
export type UpsertReservationNotificationOperationNotificationTypeEnum = typeof UpsertReservationNotificationOperationNotificationTypeEnum[keyof typeof UpsertReservationNotificationOperationNotificationTypeEnum];
